import store from '@/store'

const profile = store.state.profile

export const access = (typeAccess) => {
  if (typeAccess === 'public' || profile?.user?.type_user === 'Admin') return true
  if (typeAccess === 'admin') return false
}
